var _defs, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconFinish = function SvgIconFinish(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;opacity:0;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-890 -786)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M88,257H48v40H88Z",
    transform: "translate(842 529)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1971.5,6529.574a1,1,0,0,1,0-1.414l3.794-3.771a1,1,0,0,1,1.414,0,1,1,0,0,1,0,1.414l-3.792,3.77a1,1,0,0,1-.706.292A1,1,0,0,1-1971.5,6529.574Zm-9.1,0a1,1,0,0,1,0-1.414l12.9-12.819a1,1,0,0,1,1.414,0,1,1,0,0,1,0,1.414l-12.9,12.819a1,1,0,0,1-.706.292A1,1,0,0,1-1980.605,6529.574Zm-9.1,0a1,1,0,0,1,0-1.414l22-21.868a1,1,0,0,1,1.414,0,1,1,0,0,1,0,1.415l-22,21.868a1,1,0,0,1-.706.292A1,1,0,0,1-1989.709,6529.574Zm0-9.049a1,1,0,0,1,0-1.415l12.9-12.818a1,1,0,0,1,1.414,0,1,1,0,0,1,0,1.415l-12.9,12.818a1,1,0,0,1-.705.291A1,1,0,0,1-1989.709,6520.524Zm0-9.048a1,1,0,0,1,0-1.416l3.792-3.769a1,1,0,0,1,1.414,0,1,1,0,0,1,0,1.415l-3.794,3.771a1,1,0,0,1-.7.291A1,1,0,0,1-1989.709,6511.477Z",
    transform: "translate(2888 -5711.868)"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconFinish, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-finish.60a23350.svg";
export { ForwardRef as ReactComponent };